import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const secureframe = defineConnector({
  identifier: "secureframe",
  name: "Secureframe",
  tagLine: "Security compliance automation",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api(-uk)?\\.secureframe\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.secret.apiKey} ${app.secret.secretKey}`,
      },
    ]),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Secureframe console, go to **Profile > Company Settings > API Keys** and create a new key. Copy both the **API key** and the **secret key** (the secret is shown only once).",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "api.secureframe.com",
          target: { kind: "configuration", field: "apiHost" },
          options: [
            { value: "api.secureframe.com", label: "US (api.secureframe.com)" },
            {
              value: "api-uk.secureframe.com",
              label: "UK (api-uk.secureframe.com)",
            },
          ],
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) => ({
      url: `https://${apiHost}/users`,
      expectedStatus: [200, 403],
    }),
  },
});
